// extracted by mini-css-extract-plugin
export default {"dashboard_card":"DashboardCard_dashboard_card__BeM28"};